module.exports = __webpack_public_path__ + "static/media/sarkarizone30.3db21a2d.jpg";